//#region types
import { FileUploaderProps, TextInputProps } from "models/propTypes/wintFormPropsTypes";
import { TranslationKeys } from "translations";
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
import { IncomingInvoiceFormTypes } from "models/formTypes";
import { RegularIncomingInvoiceFormStepProps } from "models/propTypes/incomingInvoicePropTypes";
import { DimensionEnums } from "models/enums";
//#endregion
//#region components
import { FileUploader, GroupSection, TextInput, VerticalFormField } from "components/common/wintForms";
import { AccountStep, AlreadyPaidStep, CostForwardingStep, DimensionStep, PeriodisationStep } from "../_fields";
import { StaticInfoMessage, useDimensionMaps } from "components/common";
//#endregion
import cssExports from "theme/styles/main.module.scss";
import { LocalizationHelperInstance } from "utils/helpers";
import { useSelector } from "react-redux";
import { AppState } from "store";

const RegularIncomingInvoiceFormStep: React.FC<RegularIncomingInvoiceFormStepProps<IncomingInvoiceFormTypes.Todo>> = ({
  connect,
  values,
  expandableStepProps,
  incomingInvoiceProps,
  fileViewer,
}) => {
  const { invoice, dimensionAmount, showAccountSection, allwoPeriodisation, getAccountAdditionalInfoType } =
    incomingInvoiceProps;

  const { dimensions, forcedDimensionMap } = useDimensionMaps(DimensionEnums.DimensionCategory.IncomingInvoice);
  const noBankIntegration = useSelector((store: AppState) => store.auth.selectedCompany.noBankIntegration);

  return (
    <>
      {showAccountSection && (
        <AccountStep
          {...incomingInvoiceProps}
          connect={connect}
          values={values}
          expandableStepProps={expandableStepProps}
        />
      )}
      {!invoice.isAutoInvoice &&
        getAccountAdditionalInfoType(values.account?.id) !==
          WintSuperkollAPIModel.AdditionalInformationRequired.None && (
          <VerticalFormField<TextInputProps>
            Component={TextInput}
            {...connect("additionalInfoComment")}
            label={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Invoice.AdditionalInformationComment)}
            noOuterSpacing
          />
        )}
      {!invoice.isAutoInvoice &&
        getAccountAdditionalInfoType(values.account?.id) ===
          WintSuperkollAPIModel.AdditionalInformationRequired.FileOrComment && (
          <GroupSection
            header={LocalizationHelperInstance.getFormattedMessage(
              TranslationKeys.Invoice.AdditionalInformationAttachment
            )}
            description={LocalizationHelperInstance.getFormattedMessage(
              TranslationKeys.Invoice.AdditionalInformationAttachmentDescription
            )}
            className={cssExports.noBorder}
          >
            <VerticalFormField<FileUploaderProps>
              Component={FileUploader}
              {...connect("additionalInfoAttachments")}
              label={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Attachments)}
              descriptionText=""
            />
          </GroupSection>
        )}
      <AlreadyPaidStep
        connect={connect}
        values={values}
        expandableStepProps={expandableStepProps}
        isCreditInvoice={invoice.isCredit}
        noBankIntegration={noBankIntegration}
      />
      {noBankIntegration && (
        <StaticInfoMessage gutterBottom>
            {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.IncomingInvoice.NoBankIntegrationInfoMessage)}
        </StaticInfoMessage>
      )}
      {dimensions?.length > 0 && (
        <DimensionStep
          connect={connect}
          values={values}
          amount={dimensionAmount}
          isOptional={forcedDimensionMap.length === 0}
          expandableStepProps={expandableStepProps}
          fileViewer={fileViewer}
        />
      )}
      {allwoPeriodisation && (
        <PeriodisationStep
          connect={connect}
          values={values}
          expandableStepProps={expandableStepProps}
          invoice={invoice}
          netAmount={Math.abs(dimensionAmount)}
          fileViewer={fileViewer}
        />
      )}
      {values.costForwardingAvailable && (
        <CostForwardingStep connect={connect} values={values} expandableStepProps={expandableStepProps} />
      )}
    </>
  );
};

export default RegularIncomingInvoiceFormStep;
